import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const isLoggedIn = () => !!localStorage.getItem("login");

// Top-level login gate for the whole /app tree. Unlike the previous version it holds auth in
// state, reacts to localStorage being cleared (this tab or another via the `storage` event, plus
// a short poll), and renders nothing until authenticated — so protected content never flashes
// before the redirect when the cache/session is cleared.
export default function Protected(props) {
  const { Components } = props;
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(isLoggedIn);

  const checkAuth = useCallback(() => {
    if (!isLoggedIn()) {
      setAuthed(false);
      navigate("/", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    checkAuth();

    const onStorage = (e) => {
      if (e.key === null || e.key === "login" || e.key === "userIn" || e.key === "token") {
        checkAuth();
      }
    };
    window.addEventListener("storage", onStorage);
    const interval = setInterval(checkAuth, 2000);

    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(interval);
    };
  }, [checkAuth]);

  if (!authed) return null;

  return (
    <div>
      <Components />
    </div>
  );
}
